import { combineReducers } from 'redux';
import email from './email/reducer';

export default combineReducers({
  email,
});
